module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_003.png?bd602ac8300a5f63f548e3f6851db282";